import React from "react";
import Card from "components/card";
import { recognitionFilters } from "variables/constants";
import { useDispatch, useSelector } from "react-redux";
import {
    doUserReactionCreate,
    doUserReactionDelete
} from "../../../../../redux/userreaction/userReactionState";
import ReactionButton from "./ReactionButton";

const RecognitionCard = ({
    recordData,
    rcw_id,
    onLikeChange
}) => {
    const dispatch = useDispatch();
    const authUser = useSelector((state) => state.auth.user);

    const doCreate = (data) => dispatch(doUserReactionCreate(data));
    const deDelete = (data) => dispatch(doUserReactionDelete(data));

    const filterStyle = recognitionFilters.find(
        f => f.value === recordData?.recognition_type?.toLowerCase()
    );

    const senderDisplayName =
        recordData?.created_by?.id === authUser?.id
            ? "You"
            : recordData?.sender_name?.trim();

    const recipientDisplayName =
        recordData?.rcw_receiver_user_id === authUser?.id
            ? "You"
            : recordData?.recipient_name?.trim();

    return (
        <Card
            className={`text-slate-900 flex flex-col gap-6 rounded-2xl border-2
            ${filterStyle?.border} ${filterStyle?.bgColor}
            hover:shadow-lg transition-all duration-300 group`}
        >
            <div className="pb-6 p-5">
                <div className="flex items-start gap-4">

                    <div className="relative">
                        <span
                            className={`
                                relative flex items-center justify-center border-2 border-white
                                rounded-full w-12 h-12 text-white font-semibold shadow-md
                                bg-gradient-to-br ${filterStyle?.bg}
                                transition-transform duration-300
                            `}
                        >
                            {recordData?.sender_initial}
                        </span>
                    </div>

                    <div className="flex-1 min-w-0">

                        <div className="flex items-start justify-between gap-2 mb-2">

                            <div>
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="font-semibold text-sm dark:text-slate-100">
                                        {senderDisplayName}
                                    </span>

                                    {recipientDisplayName && (
                                        <>
                                            <span className="muted-text text-xs">
                                                &#8594;
                                            </span>
                                            <span className="font-semibold text-sm text-purple-600 dark:text-purple-400">
                                                {recipientDisplayName}
                                            </span>
                                        </>
                                    )}
                                </div>

                                <div className="flex items-center gap-2 mt-1">

                                    <span
                                        className={`inline-flex items-center justify-center rounded-lg font-medium
                                        w-fit whitespace-nowrap shrink-0 text-xs px-2 py-0 border title-text
                                        ${filterStyle?.bgColor} ${filterStyle?.border}`}
                                    >
                                        <span className="mr-1">
                                            {filterStyle?.icon}
                                        </span>
                                        {filterStyle?.label}
                                    </span>

                                    <span className="text-xs muted-text">
                                        {recordData?.created_at_ago}
                                    </span>

                                </div>
                            </div>
                        </div>

                        <p className="text-sm muted-text dark:text-zinc-300 mb-3 leading-relaxed">
                            {recordData?.rcw_message}
                        </p>

                        <div className="flex items-center gap-4">

                            <ReactionButton
                                type="heart"
                                recordData={recordData}
                                rcw_id={rcw_id}
                                authUser={authUser}
                                doCreate={doCreate}
                                deDelete={deDelete}
                                onChange={onLikeChange}
                            />

                            <ReactionButton
                                type="react"
                                recordData={recordData}
                                rcw_id={rcw_id}
                                authUser={authUser}
                                doCreate={doCreate}
                                deDelete={deDelete}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default RecognitionCard;